export const STEPS = [
  {label: "Step 1"},
  {label: "Step 2"},
  {label: "Step 3"}
]

export const ACCORDION_ITEMS = {
  cycleReferece: "cycleReference",
  questionLibrary: "questionLibrary",
  frequencyAndTimeframe: "frequencyAndTimeframe",
  emails: "emails",
  participants: "participants",
  whatHappensNext: "whatHappensNext"
}
